import React, { useEffect, useState } from "react";
import ReactDragListView from "react-drag-listview";
import dragIcon from "../../assets/drag-icon.svg";
import { JService } from "../api-service/ApiService";
import Button from "../design/Button";
import GModal from "../design/components/GModal";
import { enqueueSnackbar } from "notistack";

function EditOrderModal(props) {
  const {
    vnId,
    routingOrder,
    allUsers,
    allTeams,
    connectToTeam,
    handleUpdate = null,
    callDistribution,
    onClose,
    originalInboundTeam = null,
    setOriginalSettings = () => null
  } = props;

  const [teamUsers, setTeamUsers] = useState([]);

  useEffect(() => {
    // if selected team is same as the team in original Settings
    if (
      originalInboundTeam &&
      connectToTeam === originalInboundTeam && Array.isArray(routingOrder) && routingOrder?.length !== 0
    ) {
      // if routing order is already set
        const _temp = [];
        // this chunk has n square time complexity. Optimize later if required. Optimization will require backend changes.
        routingOrder?.forEach((userId) => {
          allUsers?.forEach((user) => {
            if (user.id === userId) _temp.push(user);
          });
        });
        setTeamUsers(_temp);
    }
    // else if selected team is not same as team in original settings set random order
    else {
      const selectedTeam = allTeams?.filter(
        (team) => team.id === connectToTeam
      );
      if(selectedTeam[0].users && typeof selectedTeam[0].users?.[0] === "number") {
        let usersInTeam = selectedTeam[0].users;
        usersInTeam = usersInTeam.map(id => {
          return allUsers.find(u => u.id === id);
        })
        setTeamUsers(usersInTeam);
      }
      else {
        setTeamUsers(selectedTeam[0].users);
      }
    }
  }, [allUsers, allTeams, routingOrder, connectToTeam, originalInboundTeam]);

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const _data = [...teamUsers];
      const item = _data.splice(fromIndex, 1)[0];
      _data.splice(toIndex, 0, item);
      setTeamUsers(_data);
    },
    nodeSelector: "li",
    handleSelector: "img",
  };

  const handleSave = () => {
    if(handleUpdate) {
      handleUpdate(teamUsers.map((user) => user.id));
      onClose();
      return;
    }
    JService.patch(`/api/v1/auth/virtual-numbers/calling/${vnId}/`,
      {
        routing_order: teamUsers.map((user) => user.id),
        call_distribution: callDistribution,
        inbound_team_id: connectToTeam,
        inbound_user: null,
        ivr_flow: null
      }
    )
      .then((res) => {
        if (!res?.success)
          throw new Error(
            res?.message || "Error while updating virtual number",
          );

        enqueueSnackbar(res?.message, { variant: "success" });
        setOriginalSettings(res.data);
        onClose();
      })
      .catch((err) => enqueueSnackbar(err?.message, { variant: "error" }));
  };

  return (
    <>
      <GModal
        visible={true}
        closeModal={onClose}
        heading={"Edit order"}
        body={
          <ReactDragListView {...dragProps}>
            <ol>
              {!!teamUsers &&
                teamUsers.map((user, index) => (
                  <li key={user.id} className="draggable-user">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        className="t6 regular-font nc-gray-900"
                        style={{ marginLeft: "24px" }}
                      >
                        {index + 1}
                      </p>
                      <div style={{ marginLeft: "20px" }}>
                        <p className="t6 regular-font nc-gray-900">
                          {user.name ?? user.first_name + " " + user.last_name}
                        </p>
                        <p className="t6 regular-font nc-gray-600">
                          {user.email}
                        </p>
                      </div>
                    </div>

                    <img
                      src={dragIcon}
                      style={{
                        marginRight: "9px",
                        cursor: "pointer",
                        padding: "10px",
                      }}
                    />
                  </li>
                ))}
            </ol>
          </ReactDragListView>
        }
        modalStyle={{
          maxHeight: "336px",
          width: "448px",
          padding: "32px 24px",
        }}
        bottomButtons={[
          <Button
            disabled={false}
            hierarchy="white"
            variant="contained"
            buttonText="Cancel"
            isLoading={false}
            onClick={onClose}
          />,
          <Button
            disabled={false}
            hierarchy="green"
            variant="contained"
            buttonText="Save"
            isLoading={false}
            onClick={handleSave}
          />,
        ]}
      />
    </>
  );
}

export default EditOrderModal;
